import Image from "next/image";

interface Props {
  width?: number;
  height?: number;
  style?: React.CSSProperties;
}

const Loading: React.FC<Props> = ({ width = 60, height = 60, style }) => {
  return (
    <Image
      src="/loading.svg"
      alt="loading"
      width={width}
      height={height}
      style={style}
      className="animate-spin"
    />
  );
};

export default Loading;
